import { fetch } from "src/services/apollo-fetch";
import { Query } from "../_api";

export default {
    async fetchReceiptLogUnit({ commit }, { receiptLogId, unitId }) {
        const response = await fetch.query({
            query: Query.receiptLogUnit,
            variables: { receiptLogId, unitId },
        });
        commit("setSelectedReceiptLogUnit", response.data.receiptLogUnit);
    },
};
